"use strict";
// _interview-filter.js — 社員インタビュー一覧の職種・キーワードフィルター（クライアント側）

{
  const filterLists = document.querySelectorAll(".p-lowerInterviewArchive__filterList");

  if (filterLists.length) {
    const cards = document.querySelectorAll(".p-lowerInterviewArchive__card");
    const emptyMessage = document.querySelector("[data-filter-empty]");
    const state = { job: "all", keyword: [] };

    const applyFilter = () => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const job = card.getAttribute("data-job") || "";
        const keywords = (card.getAttribute("data-keyword") || "").split(" ");
        const jobOk = state.job === "all" || job === state.job;
        const keywordOk =
          state.keyword.length === 0 ||
          state.keyword.every((keyword) => keywords.includes(keyword));
        const isVisible = jobOk && keywordOk;

        card.style.display = isVisible ? "" : "none";
        if (isVisible) visibleCount += 1;
      });

      if (emptyMessage) {
        emptyMessage.hidden = visibleCount > 0;
      }
    };

    document.querySelectorAll(".p-lowerInterviewArchive__filterBtn").forEach((button) => {
      button.addEventListener("click", () => {
        const list = button.closest(".p-lowerInterviewArchive__filterList");
        if (!list) return;

        const group = list.getAttribute("data-filter-group");
        if (!group) return;

        const value = button.getAttribute("data-filter");

        if (group === "keyword") {
          const allButton = list.querySelector('[data-filter="all"]');

          if (value === "all") {
            state.keyword = [];
            list.querySelectorAll(".p-lowerInterviewArchive__filterBtn").forEach((item) => {
              item.classList.remove("is-active");
            });
            button.classList.add("is-active");
          } else {
            const index = state.keyword.indexOf(value);
            if (index === -1) {
              state.keyword.push(value);
              button.classList.add("is-active");
            } else {
              state.keyword.splice(index, 1);
              button.classList.remove("is-active");
            }
            if (allButton) {
              allButton.classList.toggle("is-active", state.keyword.length === 0);
            }
          }
        } else {
          state[group] = value;
          list.querySelectorAll(".p-lowerInterviewArchive__filterBtn").forEach((item) => {
            item.classList.remove("is-active");
          });
          button.classList.add("is-active");
        }

        applyFilter();
      });
    });
  }
}
